import * as React from "react"
import { Navigate } from "react-router-dom"

import { NEWS_MANAGEMENT_ROUTES } from "@constants"
import AppLayout from "Layout"
import NewsManagementPage from "./index"

/** Its own section rather than a child of Management.
 *
 * The `newsManagement` module is granted per user in `DIPI_USER_MODULE`, so being on the
 * internal customer is not enough to see this in the menu — customer 0 also holds accounts
 * that are not staff. `useRoutes.jsx` does the hiding from `accessKey`; the backend enforces
 * the real check (`admin/news_management/deps.py`).
 */
export const NewsManagementRoutes = {
    path: NEWS_MANAGEMENT_ROUTES.PATH,
    title: NEWS_MANAGEMENT_ROUTES.TITLE,
    accessKey: NEWS_MANAGEMENT_ROUTES.ACCESS_KEY,
    icon: 'bullhorn',
    iconWeight: 'light',
    description: NEWS_MANAGEMENT_ROUTES.SUBTITLE,
    element: <AppLayout />,
    children: [{
        element: <Navigate to={NEWS_MANAGEMENT_ROUTES.ANNOUNCEMENTS_PATH} replace />, index: true
    }, {
        title: NEWS_MANAGEMENT_ROUTES.ANNOUNCEMENTS_TITLE,
        path: NEWS_MANAGEMENT_ROUTES.ANNOUNCEMENTS_PATH,
        dashboardKey: NEWS_MANAGEMENT_ROUTES.ANNOUNCEMENTS_ID,
        element: <NewsManagementPage />,
    }]
}
